import React from 'react';
import { Card, CardHeader, CardContent } from '../ui/card';
import { 
  Settings, 
  Shield, 
  Activity 
} from 'lucide-react';

const ProfileSection = ({ section }) => {
  const sectionConfig = {
    settings: {
      icon: Settings,
      title: 'Settings',
      content: 'Settings section coming soon...'
    },
    security: {
      icon: Shield,
      title: 'Security',
      content: 'Security section coming soon...'
    },
    activity: {
      icon: Activity,
      title: 'Recent Activity',
      content: 'Activity section coming soon...'
    }
  };

  const config = sectionConfig[section];
  if (!config) return null;

  const Icon = config.icon;

  return (
    <Card>
      <CardHeader>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2">
          <Icon className="w-5 h-5" />
          {config.title}
        </h2>
      </CardHeader>
      <CardContent>
        <p className="text-gray-600 dark:text-gray-400">{config.content}</p>
      </CardContent>
    </Card>
  );
};

export default ProfileSection;
